var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_836_40812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.91072 10.2058H1.5949C0.949768 10.2058 0.425415 9.68144 0.425415 9.03632V3.29523C0.425415 2.6501 0.949768 2.12575 1.5949 2.12575H1.80753C1.98359 2.12575 2.12648 2.26864 2.12648 2.4447C2.12648 2.62076 1.98359 2.76365 1.80753 2.76365H1.5949C1.30189 2.76365 1.06331 3.00222 1.06331 3.29523V9.03632C1.06331 9.32932 1.30189 9.5679 1.5949 9.5679H6.91072C7.20373 9.5679 7.4423 9.32932 7.4423 9.03632V8.82368C7.4423 8.64762 7.58519 8.50473 7.76125 8.50473C7.93731 8.50473 8.0802 8.64762 8.0802 8.82368V9.03632C8.0802 9.68144 7.55585 10.2058 6.91072 10.2058Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61182 7.65494H4.14653C3.5014 7.65494 2.97705 7.13058 2.97705 6.48546V1.16963C2.97705 0.524505 3.5014 0.000152588 4.14653 0.000152588H8.61182C9.25695 0.000152588 9.7813 0.524505 9.7813 1.16963V6.48546C9.7813 7.13058 9.25695 7.65494 8.61182 7.65494ZM4.14653 0.638051C3.85352 0.638051 3.61495 0.876625 3.61495 1.16963V6.48546C3.61495 6.77846 3.85352 7.01704 4.14653 7.01704H8.61182C8.90483 7.01704 9.1434 6.77846 9.1434 6.48546V1.16963C9.1434 0.876625 8.90483 0.638051 8.61182 0.638051H4.14653Z",
    fill: "#334155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_836_40812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.2064,
    height: 10.2064,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.0eb55546b0b1eeaaff5a535ce9dfe6a1.svg";
export { ForwardRef as ReactComponent };